import { render, staticRenderFns } from "./Release520Sections.vue?vue&type=template&id=21bb9b23&scoped=true&"
import script from "./Release520Sections.vue?vue&type=script&lang=js&"
export * from "./Release520Sections.vue?vue&type=script&lang=js&"
import style0 from "./Release520Sections.vue?vue&type=style&index=0&id=21bb9b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb9b23",
  null
  
)

export default component.exports